const termsOfServiceStrings = {
    seoTitle: "La Estrellita | Términos de Servicio",
    pageTitle: "Términos de Servicio",
    headerTitle: "Términos de Servicio",

    introParagraph:
        "¡Bienvenido a La Estrellita! Estos Términos de Servicio (\"Términos\") rigen tu uso de nuestro sitio web. Al acceder o usar nuestro sitio, aceptas cumplir y estar sujeto a estos Términos. Si no estás de acuerdo, por favor abstente de usar nuestro sitio web.",

    section1Title: "1. Uso del Sitio Web",
    section1Text:
        "Nuestro sitio web está destinado a proporcionar información general sobre La Estrellita, incluyendo nuestro menú, horario de atención, ubicación y detalles de contacto. Todo el contenido es solo con fines informativos y puede ser actualizado sin previo aviso.",

    section2Title: "2. Conducta del Usuario",
    section2Text:
        "Al usar nuestro sitio web, aceptas:",
    section2List: [
        "Usar el sitio solo para fines legales.",
        "No intentar acceder sin autorización a ninguna parte del sitio.",
        "Respetar todos los derechos de propiedad intelectual relacionados con el contenido proporcionado.",
    ],

    section3Title: "3. Propiedad Intelectual",
    section3Text:
        "Todo el contenido en este sitio web —incluyendo textos, imágenes, logotipos y diseño— es propiedad de La Estrellita y está protegido por leyes de derechos de autor y marcas registradas. No puedes reproducir ni distribuir ninguna parte del sitio sin nuestro consentimiento previo por escrito.",

    section4Title: "4. Enlaces de Terceros",
    section4Text:
        "Nuestro sitio web puede contener enlaces a sitios de terceros para tu conveniencia (por ejemplo, servicios de entrega o plataformas de reseñas). La Estrellita no se responsabiliza por el contenido o prácticas de esos sitios.",

    section5Title: "5. Descargo de Responsabilidad",
    section5Text:
        "La información en este sitio web se proporciona \"tal cual\" y sin garantías de ningún tipo. Aunque nos esforzamos por la precisión, La Estrellita no garantiza la integridad, confiabilidad o actualidad de la información proporcionada.",

    section6Title: "6. Limitación de Responsabilidad",
    section6Text:
        "En la medida permitida por la ley, La Estrellita no será responsable por daños derivados o relacionados con el uso de nuestro sitio web, incluyendo, entre otros, daños directos, indirectos, incidentales o consecuentes.",

    section7Title: "7. Modificaciones",
    section7Text:
        "La Estrellita se reserva el derecho de actualizar o modificar estos Términos en cualquier momento sin previo aviso. Tu uso continuado del sitio después de que los cambios se hayan publicado indica tu aceptación de los Términos actualizados.",

    section8Title: "8. Contáctanos",
    section8Text: "Si tienes alguna pregunta o inquietud sobre estos Términos, por favor contáctanos en",
    contactEmail: " laestrellitasc@gmail.com",

    consentText:
        "Al usar nuestro sitio web, reconoces que has leído, comprendido y aceptas estos Términos de Servicio.",
};

export default termsOfServiceStrings;
